import {get, post} from "@/config/api";


const state = {
  feedPage: {},
};

const getters = {};

const mutations = {};

const actions = {
  FeedFrontPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/feed_wt/`, params).then((data) => {
        if (data.code === 0) {
          state.feedPage = data
        }
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },


  FeedFrontPageComic({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/comic_wt/`, params).then((data) => {
        if (data.code === 0) {
          state.feedPage = data
        }
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },


  FeedGoodsPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/goods_wt/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  FeedMomentPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/moment/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },


  FeedDiscoveryPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/discovery/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

  FeedCategoryPage({}, params) {
    return new Promise((resolve, reject) => {
      get(`feed/page/category_comic_wt/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
